module.exports = __webpack_public_path__ + "img/e3-header.37eedb2b.png";